module.exports = __webpack_public_path__ + "static/media/Level_8.03592c6d.png";